import { isNull } from 'lodash';
import React from 'react';
import { Options } from 'react-select';

import { Dropdown, DropdownOption } from '../../shared/dropdown/Dropdown';
import { ConfirmationModal } from '../../shared/modal/ConfirmationModal';
import styles from './Documents.module.scss';

export interface OriginalDocumentAgreementLinkModalProps {
    isOpen: boolean;
    closeModal: () => void;
    dropdownOption: DropdownOption | null;
    dropdownOptions: DropdownOption[];
    setParentAgreementType: (parentOption: DropdownOption | Options<DropdownOption> | null) => void;
    confirmParentLink: () => void;
}

export const OriginalDocumentAgreementLinkModal: React.FC<OriginalDocumentAgreementLinkModalProps> = ({ isOpen, closeModal, dropdownOption, dropdownOptions, setParentAgreementType, confirmParentLink }) => (
    <ConfirmationModal
        isOpen={isOpen}
        closeModal={closeModal}
        testId='original-document-agreement-link-modal'
        confirm={confirmParentLink}
        confirmDisabled={isNull(dropdownOption)}
    >
        <div className={styles.agreementLinkSelectWrapper}>
            <div className={styles.agreementLinkSelectTitle}>Select Agreement Type</div>
            <Dropdown
                value={dropdownOption}
                options={dropdownOptions}
                onChange={setParentAgreementType}
                menuPortalTarget={document.body}
                placeholder='Select Agreement Type'
            />
        </div>
    </ConfirmationModal>
);
